import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
  Button,
  Grid,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  modal: {
    "& .MuiDialog-paper": {
      minWidth: 600,
      maxWidth: 1200,
      marginTop: '10rem'
    },
  },
  modalTitle: {
    fontWeight: "bold",
    fontSize: "1.25rem",
  },
  formRow: {
    marginBottom: theme.spacing(2),
  },
  disabledField: {
    "& .MuiInputBase-input": {
      color: "#999",
    },
    "& .MuiInputLabel-root": {
      color: "#999",
    },
  },
  cancelBtn: {
    color: "#666",
    borderColor: "#ccc",
    marginRight: theme.spacing(1),
  },
  updateBtn: {
    backgroundColor: "#4472c4",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#303f9f",
    },
  },
}));

const EditUserModal = ({ open, onClose, selectedUser, onUpdateUser }) => {
  const classes = useStyles();
  const [userStatus, setUserStatus] = useState("");

  useEffect(() => {
    if (selectedUser) {
      setUserStatus(selectedUser.IsActive || "");
    }
  }, [selectedUser]);

  const handleClose = () => {
    setUserStatus("");
    onClose();
  };

  const handleUpdate = () => {
    if (onUpdateUser && selectedUser) {
      onUpdateUser(selectedUser.UserID, userStatus);
    }
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} className={classes.modal}  disableBackdropClick={true}
      disableEscapeKeyDown={true}>
      <DialogTitle>
        <Typography className={classes.modalTitle}>Edit User</Typography>
      </DialogTitle>
      <DialogContent>
        {selectedUser && (
          <Grid container spacing={2}>
            <Grid item xs={6} className={classes.formRow}>
              <TextField
                fullWidth
                label="First Name"
                value={selectedUser.Full_Name?.split(' ')[0] || ''}
                disabled
                className={classes.disabledField}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6} className={classes.formRow}>
              <TextField
                fullWidth
                label="Last Name"
                value={selectedUser.Full_Name?.split(' ').slice(1).join(' ') || ''}
                disabled
                className={classes.disabledField}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} className={classes.formRow}>
              <TextField
                fullWidth
                label="Email"
                value={selectedUser.Email || ''}
                disabled
                className={classes.disabledField}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6} className={classes.formRow}>
              <TextField
                fullWidth
                label="Role Type"
                value={selectedUser.Role_Type || ''}
                disabled
                className={classes.disabledField}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6} className={classes.formRow}>
              <TextField
                fullWidth
                label="Team"
                value={selectedUser.Display_Name || ''}
                disabled
                className={classes.disabledField}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} className={classes.formRow}>
              <FormControl variant="outlined" style={{width: '200px'}}>
                <InputLabel>Status</InputLabel>
                <Select
                  value={userStatus}
                  onChange={(e) => setUserStatus(e.target.value)}
                  label="Status"
                >
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={handleClose}
          variant="outlined"
          className={classes.cancelBtn}
        >
          Cancel
        </Button>
        <Button 
          onClick={handleUpdate}
          variant="contained"
          className={classes.updateBtn}
        >
          Update User
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditUserModal;